import React from "react";
import { useForm } from "react-hook-form";
import { PDFDownloadLink } from "@react-pdf/renderer";

import {PdfDocument} from './pdf'
import '../assets/css/form.css';

// The following component is an example of your existing Input Component 
const Input = ({ label, register, required, allDisabled, value}) => ( 
  <>
    <label>{label}</label>
    {console.log('value', value)}
    <input name={label} disabled={allDisabled} ref={register({ required })} value={value} />
  </>
);

const InputNum = ({ label, register, required, allDisabled }) => ( 
  <>
    <label>{label}</label>
    <input type="number" disabled={allDisabled} name={label} ref={register({ required })} />
  </>
);

// The following component is an example of your existing Input Component 
const InputDate = ({ label, register, required, allDisabled }) => ( 
  <>
    <label>{label}</label>
    <input type="date" disabled={allDisabled} name={label} ref={register({ required })} />
  </>
);

// The following component is an example of your existing Input Component 
const TextArea = ({ label, register, required, allDisabled }) => ( 
  <>
    <label>{label}</label>
    <textarea rows={10} cols={40} name={label} disabled={allDisabled} ref={register({ required })}></textarea>
  </>
);

// you can use React.forwardRef to pass the ref too
const Select = React.forwardRef(({ label, register, allDisabled }, ref) => ( 
  <>
    <label>{label}</label>
    <select name={label} ref={ref} disabled={allDisabled}>
      <option value="Covid-19">Covid-19</option>
      <option value="TB">TB</option>
      <option value="Pneumonia">Pneumonia</option>
      <option value="Effusion">Effusion</option>
      <option value="Mass">Mass</option>
      <option value="Nodule">Nodule</option>
      <option value="No_Finding">No_Finding</option>
      <option value="Healthy">Healthy</option>
    </select>
  </>
));

// you can use React.forwardRef to pass the ref too
const Radio = React.forwardRef(({ label, register, values = [], allDisabled }, ref) => ( 
    <>
      <label>{label}</label>
      <div className="radio-container">
      {
        values.map(v => <label className="radio-label"><input name={label} disabled={allDisabled} type="radio" value={v} ref={ref({ required: true })}/>{v}</label>)
      }
      </div>
    </>
  ));

export default function App({submit, results, allDisabled, download, submitData, downloadData}) {
  const { register, handleSubmit } = useForm({defaultValues: submitData});
  const onSubmit = data => submit(data);
   
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Input label="Patient ID" register={register} required allDisabled={allDisabled} />
        <Radio label="Gender" ref={register} values={["Male", "Female"]} allDisabled={allDisabled}/>
        <InputNum label="Age" register={register} required allDisabled={allDisabled} />
        <div>{ results.result && <span className="ml-finding-show">(AI finding - <span style={{color: 'red'}}>{Object.keys(results.result)[0] === 'COVID19' ? `${Object.keys(results.result)[0]} (Suspect)` : Object.keys(results.result)[0]}</span>)</span>}</div>
        <Select label="Doctor Finding" ref={register} allDisabled={allDisabled} />
        <Radio label="Survival" ref={register} values={["Yes", "No"]} allDisabled={allDisabled}/>
        <Radio label="View" ref={register} values={["PA", "Non PA"]} allDisabled={allDisabled}/>
      </div>
      <div>
        <InputDate label="Date of X-Ray taken" register={register} required allDisabled={allDisabled}/>
        <Input label="Location" register={register} required allDisabled={allDisabled}/>
        <TextArea label="Clinical note" register={register} required allDisabled={allDisabled}/>
        <TextArea label="Other notes" register={register} required allDisabled={allDisabled}/>
        {
          allDisabled ?
          <div style={{marginTop: 10}}>
            <PDFDownloadLink
                document={<PdfDocument input={URL.createObjectURL(downloadData.input)} result={downloadData.result} output={downloadData.output} data={submitData} />}
                fileName={`PatientID${results.img_id}.pdf`}
                onClick={download}
                className="ano-form"
                style={{
                  textDecoration: "none",
                }}
              >
                {({ blob, url, loading, error }) =>
                  loading ? "Loading document..." : "Download Pdf"
                }
            </PDFDownloadLink>
          </div>
          :
          <input type="submit" className="ano-form"/>
        }
      </div>
    </form>
  );
}